module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	"use strict";

	fox.registerWidget('UserOffer', {
		offersWidgets: {},
		// _loaded: false,
		_actionsHistory: [],
		_actions: [],

		configure: function () {
			this.registerOptions('', {
				widgets: {
					// offerApi: {
					// 	widget: 'UserOfferApi'
					// }
					loadOffersDl: {
						widget: 'Datalayer',
						method: 'offer.loadOffers',
						fields: [
							'id', 'type', 'state', 'settings()', 'expireDate', 'siteId',
							'offerId.id', 'offerId.type',
							'userOffer.id', 'userOffer.state', 'userOffer.context', 'userOffer.expireDate', 'userOffer.userId'
						]
					},
					sendOfferActionApi: {
						widget: 'Api',
						method: 'offer.checkAction'
					},
					reloadOfferApi: {
						widget: 'Api',
						method: 'offer.getUserOffer'
					},
					updateOfferApi: {
						widget: 'Api',
						method: 'offer.update'
					}
				},
				handleWom: {
					loadOffers: {
						widget: '#loadOffersDl',
						event: ['loaded'],
						callback: 'prepareOffers'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			fox.UserOffer || Object.defineProperty(fox, 'UserOffer', {
				get: function() {return fox.site.rwom1('.UserOffer');}
			});

			this.callParent('init', arguments);
		},

		loadOffers: function () {
			this.loadOffersDl.load();
		},

		running: function () {
			this.loadOffersDl = this.rwom1('#loadOffersDl');
			this.reloadOfferApi = this.rwom1('#reloadOfferApi');
			this.sendOfferActionApi = this.rwom1('#sendOfferActionApi');
			this.updateOfferApi = this.rwom1('#updateOfferApi');

			if (fox.site.member) {
				this.loadOffers();
			}

			this.callParent('running', arguments);
		},

		prepareOffers: function (obj, offersDl) {
			if (!offersDl.isLoaded()) {
				return false;
			}

			var offer, actions;
			while (offer = offersDl.iterateObject('offers')) {
				var offerAlias = offer.get('offerId.alias');
				var offerSettings = offer.get('settings()');
				var offerWidget = this.embedWidget(offerAlias, offerSettings.widget.name, {offerSettings: offerSettings});

				if (offerWidget) {
					offerWidget.prepare(this, offer);
					this.offersWidgets[offerAlias] = offerWidget;

					if (actions = offerWidget.getActions()) {
						// this._actions = fox._.union(this._actions, offerSettings.actions);
						this._actions = fox.merge(this._actions, actions);
					}
				} else {
					this.log('UserOffer embeding offer failed: ' + offerSettings.widget.name, {
						section: 'UserOffer',
						action: 'prepareOffers',
						widgetName: offerSettings.widget.name,
						userId: fox.site.member.getObjectValue('id'),
						offerAlias: offerAlias,
						offerId: offer.get('offerId.id'),
						offerSiteId: offer.get('id')
					});
				}
			}

			this.checkAction('offersPrepared');

			this.callActionsFromHistory();
		},

		callActionsFromHistory: function () {
			if (this._actionsHistory.length > 0) {
				for (var i = 0; i < this._actionsHistory.length; i++) {
					var history = this._actionsHistory[i];
					delete this._actionsHistory[i];
					this.checkAction(history.action, history.options);
				}
			}
		},

		checkAction: function (action, options) {
			if (!this.loadOffersDl.isLoaded()) {
				this._actionsHistory.push({action: action, options: options});
				return true;
			}

			if (this._actions.indexOf(action) === -1) {
				return false;
			}

			this.log('UserOffer dispatch event: ' + action, {
				section: 'UserOffer',
				action: 'checkAction',
				actionName: action,
				userId: fox.site.member.getObjectValue('id')
			});
			this.dispatchEvent(action, options);

			return true;
		},

		sendOfferAction: function (action, offerAlias, params, callback) {
			this.sendOfferActionApi.send({
				action: action,
				offerAlias: offerAlias,
				params: params
			});

			if (callback) {
				this.waitEvent(this.sendOfferActionApi, ['failure', 'ready'], callback, {});
			}
		},

		getOfferAction: function (action, offerAlias) {
			return this.sendOfferActionApi.prepareAddressAndParams({
				action: action,
				alias: offerAlias
			});
		},

		updateOffer: function (action, offerAlias, values, withoutSave) {
			if (!withoutSave) {
				this.updateOfferApi.send({
					action: action,
					alias: offerAlias,
					values: values
				});
			}
		},

		reloadOffer: function (offerAlias, callback) {
			this.reloadOfferApi.send({
				alias: offerAlias
			});

			if (callback) {
				this.waitEvent(this.reloadOfferApi, ['failure', 'ready'], callback, {});
			}
		},

		log: function (text, tags) {
			fox.callApi('offer.logger', {
				text: text,
				tags: tags
			});
		}
	}, 'Controller');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/offer/UserOffer.js
// module id = 126
// module chunks = 4